import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://axialis.hr';
const DEFAULT_IMAGE = `${SITE_URL}/images/home-bg.jpg`;

const SEO = ({ title, description, keywords, name, type, path, image }) => {
  // Canonical URL for this page; path should start with "/" (e.g. "/technology")
  const canonicalUrl = `${SITE_URL}${path || '/'}`;
  const imageUrl = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <link rel='canonical' href={canonicalUrl} />
      {/* End standard metadata tags */}

      {/* Facebook / Open Graph tags */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Axialis" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      {/* End Facebook tags */}

      {/* Twitter tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {/* End Twitter tags */}
    </Helmet>
  );
}

SEO.defaultProps = {
  title: 'Axialis - Electric Motors | Next Generation Axial Flux Technology',
  description: 'Axialis is developing yokeless axial flux electric motors for automotive applications. The cutting edge of axial flux technology with integrated water cooling.',
  keywords: 'axial flux motor, electric motor, automotive, EV, water cooling, high power density, Axialis',
  name: 'Axialis',
  type: 'website',
  path: '/',
  image: DEFAULT_IMAGE
};

export default SEO;
